import { Info } from 'phosphor-react'
import { useCallback, useEffect, useMemo, useState } from 'react'
import {
  Col,
  Form,
  Modal,
  OverlayTrigger,
  Row,
  Table,
  Tooltip,
} from 'react-bootstrap'
import { ArrowClockwise } from 'react-bootstrap-icons'
import { toast } from 'react-toastify'
import { useOrdenation } from '../../../../../../hooks/useOrdenation'
import WmsInventarioContagemService from '../../../../../../services/database/WmsInventarioContagemService'
import { getValue } from '../../../../../../utils/getValue'
import { sendErrorApiMessage } from '../../../../../../utils/sendErrorApiMessage'
import { ContentLoading } from '../../../../../ContentLoading'
import { CustomButton } from '../../../../../CustomButton'
import { CustomSpinner } from '../../../../../CustomSpinner'

export function ModalContagens({ isOpen, onClose, os }) {
  const [contagens, setContagens] = useState([])
  const [isContagensLoading, setIsContagensLoading] = useState(true)
  const [isGetChildrenLoading, setIsGetChildrenLoading] = useState({})
  const [countChildren, setCountChildren] = useState({})
  const [search, setSearch] = useState({
    id: '',
    status: '',
    contagem: '',
    codendereco: '',
    predio: '',
    apto: '',
    sku: '',
    tipoender: '',
  })

  const filteredContagens = useMemo(() => {
    let data = contagens

    if (search.codendereco) {
      data = data.filter((contagem) =>
        String(contagem.codendereco).includes(search.codendereco),
      )
    }

    if (search.deposito) {
      data = data.filter((contagem) =>
        String(contagem.deposito).includes(search.deposito),
      )
    }

    if (search.rua) {
      data = data.filter((contagem) =>
        String(contagem.rua).includes(search.rua),
      )
    }

    if (search.predio) {
      data = data.filter((contagem) =>
        String(contagem.predio).includes(search.predio),
      )
    }

    if (search.nivel) {
      data = data.filter((contagem) =>
        String(contagem.nivel).includes(search.nivel),
      )
    }

    if (search.apto) {
      data = data.filter((contagem) =>
        String(contagem.apto).includes(search.apto),
      )
    }

    if (search.tipoender) {
      data = data.filter((contagem) =>
        String(contagem.tipoender).includes(search.tipoender),
      )
    }

    if (search.sku) {
      data = data.filter((contagem) =>
        String(contagem.sku).includes(search.sku),
      )
    }

    return data
  }, [
    contagens,
    search.apto,
    search.tipoender,
    search.codendereco,
    search.deposito,
    search.nivel,
    search.predio,
    search.rua,
    search.sku,
  ])

  const {
    filteredItems: orderedItems,
    Th,
    Paginate,
    itemsPerPage,
    setItemsPerPage,
  } = useOrdenation(filteredContagens, 'quantidade', 'desc')

  function handleChange(e) {
    const { name, value } = e.target

    setSearch((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  async function handleSearchChildren(
    { inventario_id, codendereco, os_id, numero_contagem, sku },
    index,
  ) {
    try {
      setIsGetChildrenLoading((prevState) => ({
        ...prevState,
        [index]: true,
      }))

      const children = await WmsInventarioContagemService.getChildren({
        inventario_id,
        codendereco,
        os_id,
        numero_contagem,
        sku,
      })

      setCountChildren({
        [index]: children,
      })
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao buscar produtos filhos na contagem')
    } finally {
      setIsGetChildrenLoading((prevState) => ({
        ...prevState,
        [index]: false,
      }))
    }
  }

  const loadCounts = useCallback(async () => {
    try {
      setIsContagensLoading(true)

      const data = await WmsInventarioContagemService.getByOs(os.id)

      setCountChildren({})
      setContagens(data)
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao buscar contagens')
    } finally {
      setIsContagensLoading(false)
    }
  }, [os.id])

  useEffect(() => {
    loadCounts()
  }, [loadCounts])

  return (
    <>
      <Modal
        show={isOpen}
        onHide={onClose}
        centered
        dialogClassName="custom-modalzpl"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            CONTAGENS DE <strong>{os.descricao}</strong>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row className="mb-4">
            <Col>
              <Form.Label>End.</Form.Label>
              <Form.Control
                name="codendereco"
                value={search.codendereco}
                onChange={handleChange}
              />
            </Col>

            <Col>
              <Form.Label>Dep.</Form.Label>
              <Form.Control
                name="deposito"
                value={search.deposito}
                onChange={handleChange}
              />
            </Col>

            <Col>
              <Form.Label>Rua</Form.Label>
              <Form.Control
                name="rua"
                value={search.rua}
                onChange={handleChange}
              />
            </Col>

            <Col>
              <Form.Label>Prédio</Form.Label>
              <Form.Control
                name="predio"
                value={search.predio}
                onChange={handleChange}
              />
            </Col>

            <Col>
              <Form.Label>Nvl</Form.Label>
              <Form.Control
                name="nivel"
                value={search.nivel}
                onChange={handleChange}
              />
            </Col>

            <Col>
              <Form.Label>Apto</Form.Label>
              <Form.Control
                name="apto"
                value={search.apto}
                onChange={handleChange}
              />
            </Col>

            <Col>
              <Form.Label>Tipo</Form.Label>
              <Form.Select
                name="tipoender"
                value={search.tipoender}
                onChange={handleChange}
              >
                <option value="">Selecione</option>
                <option value="AE">AE</option>
                <option value="AP">AP</option>
              </Form.Select>
            </Col>

            <Col>
              <Form.Label>SKU</Form.Label>
              <Form.Control
                name="sku"
                value={search.sku}
                onChange={handleChange}
              />
            </Col>
          </Row>

          <Row>
            <Col xs={2}>
              <Form.Label>Contagens p/ pág.</Form.Label>
              <Form.Select
                value={itemsPerPage}
                onChange={(e) => setItemsPerPage(e.target.value)}
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </Form.Select>
            </Col>

            <Col>
              <div
                style={{
                  height: '100%',
                  display: 'flex',
                  alignItems: 'flex-end',
                  justifyContent: 'flex-start',
                  gap: 5,
                }}
              >
                <CustomButton
                  noMargin
                  title="Recarregar"
                  onClick={loadCounts}
                  isDisabled={isContagensLoading}
                >
                  <ArrowClockwise />
                </CustomButton>
              </div>
            </Col>
          </Row>

          <ContentLoading
            isLoading={isContagensLoading}
            loadingText="Carregando contagens..."
          >
            <Table
              bordered
              striped
              responsive
            >
              <thead>
                <tr>
                  <th colSpan="11">
                    <div
                      style={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'flex-end',
                      }}
                    >
                      <p
                        style={{
                          all: 'unset',
                        }}
                      >
                        Mostrando {orderedItems.length} de{' '}
                        {filteredContagens.length}
                      </p>
                    </div>
                  </th>
                </tr>
                <tr>
                  <Th
                    label="ID"
                    value="id"
                  />
                  <Th
                    label="Nº Cont."
                    value="numero_contagem"
                  />

                  <Th
                    label="Cód. End."
                    value="codendereco"
                  />
                  <Th
                    label="Dep."
                    value="deposito"
                  />
                  <Th
                    label="Rua"
                    value="rua"
                  />
                  <Th
                    label="Préd."
                    value="predio"
                  />
                  <Th
                    label="Nvl"
                    value="nivel"
                  />
                  <Th
                    label="Apto"
                    value="apto"
                  />
                  <Th
                    label="Tipo"
                    value="tipoender"
                  />
                  <Th
                    label="SKU"
                    value="sku"
                  />
                  <Th
                    label="Qtd"
                    value="quantidade"
                  />
                </tr>
              </thead>

              <tbody>
                {orderedItems.map((contagem, index) => (
                  <>
                    <tr key={contagem.id}>
                      <td>{contagem.id}</td>
                      <td>{getValue(contagem.numero_contagem)}</td>
                      <td>{getValue(contagem.codendereco)}</td>
                      <td>{getValue(contagem.deposito)}</td>
                      <td>{getValue(contagem.rua)}</td>
                      <td>{getValue(contagem.predio)}</td>
                      <td>{getValue(contagem.nivel)}</td>
                      <td>{getValue(contagem.apto)}</td>
                      <td>{getValue(contagem.tipoender)}</td>
                      <td>
                        {contagem.is_parent ? (
                          <div
                            style={{
                              display: 'flex',
                              gap: 5,
                            }}
                          >
                            <OverlayTrigger
                              overlay={
                                <Tooltip>
                                  {isGetChildrenLoading[index]
                                    ? 'Carregando...'
                                    : ' Produto pai. Dê dois cliques para buscar os filhos'}
                                </Tooltip>
                              }
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 5,
                                  cursor: 'pointer',
                                }}
                              >
                                {isGetChildrenLoading[index] ? (
                                  <CustomSpinner
                                    color="#045DB5"
                                    size={20}
                                  />
                                ) : (
                                  <Info
                                    color="#045DB5"
                                    size={20}
                                  />
                                )}

                                <p
                                  onDoubleClick={() => {
                                    countChildren[index]
                                      ? setCountChildren({})
                                      : !contagem.quantidade ||
                                          Number(contagem.quantidade) === 0
                                        ? toast.info(
                                            'Ainda não há contagens para este produto',
                                          )
                                        : handleSearchChildren(
                                            {
                                              codendereco: contagem.codendereco,
                                              inventario_id:
                                                contagem.inventario_id,
                                              os_id: os.id,
                                              numero_contagem:
                                                contagem.numero_contagem,
                                              sku: contagem.sku,
                                            },
                                            index,
                                          )
                                  }}
                                  style={{
                                    color: contagem.is_parent
                                      ? '#045DB5'
                                      : 'black',
                                    margin: 0,
                                  }}
                                >
                                  {getValue(contagem.sku)}
                                </p>
                              </div>
                            </OverlayTrigger>
                          </div>
                        ) : (
                          <p
                            style={{
                              color: 'black',
                              margin: 0,
                            }}
                          >
                            {getValue(contagem.sku)}
                          </p>
                        )}
                      </td>
                      <td>{getValue(contagem.quantidade)}</td>
                    </tr>

                    {countChildren[index] &&
                      countChildren[index].length > 0 && (
                        <tr>
                          <td colSpan={11}>
                            <Table>
                              <thead>
                                <tr>
                                  <th>ID</th>
                                  <th>SKU</th>
                                  <th>Descrição</th>
                                  <th>Quantidade</th>
                                </tr>
                              </thead>

                              <tbody>
                                {countChildren[index].map((child) => (
                                  <tr>
                                    <td>{child.id}</td>
                                    <td>{child.sku_coleta}</td>
                                    <td>{child.descricao}</td>
                                    <td>{child.quantidade}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          </td>
                        </tr>
                      )}
                  </>
                ))}
              </tbody>
            </Table>

            <Paginate />
          </ContentLoading>
        </Modal.Body>
      </Modal>
    </>
  )
}
